module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA40lEQVQ4ja3SwSrFQRTH8c+I1WUnJaxsLLCwsSEv4RGUnZdBd+UR5BUs2ShLpCyFIlZWR3PNrX/618wtvzo1Nb/zPefMHP+iiBjG5DrJtZNfwDcO8NzY0CLOUkozCuAhIkwYTzl3uhCXcI57rFaqP2INC90R9jHEPG4qgC284jCldDEeIcduRFw1jHEdETv53B1hfN7GZ6WDuW5eF7COOxxXAEfYwOVfwCZucVoB7BXASFOdi0F+jkqy4hn0AWbx3gD4KN7eDl4aANnTC1jBVwMg/9JyHyAvx2g9K8qetwZfg/ADYBawP0YU2eoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/czNav.png
// module id = LpPb
// module chunks = 95